import { StoreApi } from 'zustand';
import { MeetingSlice } from './types';
import {
  fetchMeetingAudioUrl,
  fetchAuthorizedMeetings,
  fetchMeetingReportList,
  fetchMeetingFullReport,
  exportMeetingReports,
  fetchMeetingUsageStats,
  fetchWhatsappReportList,
  fetchWhatsappFullReport,
  exportWhatsappReports,
} from 'api/api';
import {
  FetchMeetingAudioUrlRequest,
  FetchMeetingAudioUrlResponse,
  FetchAuthorizedMeetingsResponse,
  MeetingEvaluationResult,
  MeetingCriteriaFeedback,
  FetchMeetingUsageStatsRequest,
  FetchMeetingUsageStatsResponse,
} from 'api-types';

export const createMeetingSlice = (
  set: StoreApi<MeetingSlice>['setState'],
  get: StoreApi<MeetingSlice>['getState']
): MeetingSlice => ({
  fetchMeetingAudioUrl: async (
    req: FetchMeetingAudioUrlRequest
  ): Promise<FetchMeetingAudioUrlResponse> => {
    return await fetchMeetingAudioUrl(req);
  },
  fetchAuthorizedMeetings: async (): Promise<FetchAuthorizedMeetingsResponse> => {
    return await fetchAuthorizedMeetings();
  },
  fetchMeetingReportList: async (req) => {
    const response = await fetchMeetingReportList(req);
    return response;
  },
  fetchMeetingFullReport: async req => {
    const response = await fetchMeetingFullReport(req);
    return response;
  },
  exportMeetingReports: async req => {
    const response = await exportMeetingReports(req);
    return response;
  },
  fetchMeetingUsageStats: async (
    req: FetchMeetingUsageStatsRequest,
  ): Promise<FetchMeetingUsageStatsResponse> => {
    return await fetchMeetingUsageStats(req);
  },
  fetchWhatsappReportList: async (req) => {
    const response = await fetchWhatsappReportList(req);
    return response;
  },
  fetchWhatsappFullReport: async (req) => {
    const response = await fetchWhatsappFullReport(req);
    return response;
  },
  exportWhatsappReports: async (req) => {
    const response = await exportWhatsappReports(req);
    return response;
  },
});

export function findTopMostCategory(
  evaluationContent: MeetingEvaluationResult
): { qualificationScore: string; criteria: string } | undefined {
  const { criteriaFeedback } = evaluationContent;
  if (!criteriaFeedback?.length) return undefined;

  const priorityOrder = ['Strong Yes', 'Yes', 'Maybe', 'No'];

  for (const priority of priorityOrder) {
    const match = criteriaFeedback.find(
      (c: MeetingCriteriaFeedback) => c.qualificationScore === priority
    );
    if (match) {
      return {
        qualificationScore: match.qualificationScore || '',
        criteria: match.criteria || '',
      };
    }
  }

  return undefined;
}
